import formatDateLabel from "../methods/utils/formatDateLabel";
import formatYAxisLabel from "../methods/utils/formatYAxisLabel"

// link to documentation: https://www.highcharts.com/demo/highcharts/pie-chart
export default function (props) {
    // if label categories is date types we want to format them
    props.categories = props.categories.map((category) => formatDateLabel(category)) 

    return {
        chart: {
            type: props.graphType,
            zooming: {
                type: 'xy'
            },
            panning: {
                enabled: true,
                type: 'xy'
            },
            panKey: 'shift'
        },
        title: {
            text: props.title,
            align: 'left',

        },
        subtitle: {
            text: props.subtitle,
            align: 'left',
        },
        yAxis: {
            title: {
                text: props.yaxisTitle
            },
            labels: {
                formatter: function () {
                    return `${formatYAxisLabel(this.value, props.yAxisDecimals)}${props.yaxisLabelFormat}`;
                }
            },
            accessibility: {
                description: props.accaccessibilityDescriptionYaxis
            }
        },
        xAxis: {
            title: {
                text: props.xaxisTitle
            },
            accessibility: {
                description: props.accaccessibilityDescriptionXaxis,
                rangeDescription: props.accaccessibilityRangeDescriptionXaxis
            },
            // handle this within a logic function
            categories: props.categories,
            tickPositioner: props.tickPositioner, // a function
            labels: {
                formatter: function () {
                    return this.value;
                }
            },
            style: {
                fontSize: 20
            }
        },
        tooltip: {
            shared: true,
            crosshairs: true,
            valueSuffix: props.tooltipValueSuffix,
            valueDecimals: props.yAxisDecimals,
            useHTML: true,
            headerFormat: '<table><tr><th colspan="2">{point.key}</th></tr>',
                pointFormat: '<tr><td><span style="color:{color}">\u25CF</span> {series.name}: ' +
                    '</td>' +
                    '<td style="text-align: right"><b>{point.y} {props.tooltipValueSuffix}</b></td></tr>',
                footerFormat: '</table>',
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: [{
                    enabled: true,
                    distance: 20,
                    style: {
                        fontSize: 12
                    }
                }, {
                    enabled: true,
                    distance: -40,
                    format: '{point.percentage:.1f}' + props.tooltipValueSuffix,
                    style: {
                        fontSize: 14,
                        textOutline: 'none',
                        opacity: 0.7
                    },
                    filter: {
                        operator: '>',
                        property: 'percentage',
                        value: 10
                    }
                }]
            }
        },
        colors: props.colors,
        series: props.seriesData,
        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
            }]
        }
    }
}
